/**
 * Represents the scroll position of an element.
 */
export interface ScrollPosition {
    /** The vertical scroll position. */
    scrollTop: number;
    /** The horizontal scroll position. */
    scrollLeft: number;
}

/**
 * Retrieves the scroll position of a given window (or the current window by default).
 *
 * @param win - The window object to retrieve the scroll position from. Defaults to the current window.
 * @returns The scroll position object containing the scrollTop and scrollLeft values.
 */
export const getScrollPosition = (win: Window = window): ScrollPosition => ({
    scrollTop: Math.round(
        win.pageYOffset || // legacy alias of scrollY
        win.scrollY || // most modern browsers
        win.document.documentElement.scrollTop || // IE9+
        win.document.body?.scrollTop || // legacy fallback for old mobile browsers, IE8 and below
        0 // default value if no scroll position is available
    ),
    scrollLeft: Math.round(
        win.pageXOffset || // legacy alias of scrollX
        win.scrollX || // most modern browsers
        win.document.documentElement.scrollLeft || // IE9+
        win.document.body?.scrollLeft || // legacy fallback for old mobile browsers, IE8 and below
        0 // default value if no scroll position is available
    ),
});
